import { render, staticRenderFns } from "./EvaluaCurso.vue?vue&type=template&id=6bcd9db4&scoped=true"
import script from "./EvaluaCurso.vue?vue&type=script&lang=js"
export * from "./EvaluaCurso.vue?vue&type=script&lang=js"
import style0 from "./EvaluaCurso.vue?vue&type=style&index=0&id=6bcd9db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd9db4",
  null
  
)

export default component.exports